import { createAction } from '@reduxjs/toolkit'

import type {
  AddScheduleTemplateRequestPayload,
  AddStScheduledExerciseRequestPayload,
  AddStScheduledExerciseSuccessPayload,
  DeleteStScheduledExercisesByIdsRequestPayload,
  DeleteStScheduledExercisesByIdsSuccessPayload,
  EditScheduleTemplateRequestPayload,
  EditStScheduledExercisesByIdsRequestPayload,
  EditStScheduledExercisesByIdsSuccessPayload,
  EditStScheduledExerciseSettingsByIdsRequestPayload,
  EditStScheduledExerciseSettingsByIdsSuccessPayload,
  GetPartialSingleScheduleTemplateSuccessPayload,
  GetScheduleTemplatesSuccessPayload,
  GetSingleScheduleTemplateRequestPayload,
  GetSingleScheduleTemplateSuccessPayload,
  RemoveScheduleTemplateRequestPayload,
  RemoveScheduleTemplateSuccessPayload,
  ScheduleTemplateModel
} from './types'

export const getScheduleTemplatesRequest = createAction(
  'GET_SCHEDULE_TEMPLATES_REQUEST'
)
export const getScheduleTemplatesSuccess =
  createAction<GetScheduleTemplatesSuccessPayload>(
    'GET_SCHEDULE_TEMPLATES_SUCCESS'
  )
export const getScheduleTemplatesFailed = createAction(
  'GET_SCHEDULE_TEMPLATES_FAILED'
)

export const getSingleScheduleTemplateRequest =
  createAction<GetSingleScheduleTemplateRequestPayload>(
    'GET_SINGLE_SCHEDULE_TEMPLATE_REQUEST'
  )
export const getSingleScheduleTemplateSuccess =
  createAction<GetSingleScheduleTemplateSuccessPayload>(
    'GET_SINGLE_SCHEDULE_TEMPLATE_SUCCESS'
  )
export const getSingleScheduleTemplateFailed = createAction(
  'GET_SINGLE_SCHEDULE_TEMPLATE_FAILED'
)

export const getPartialSingleScheduleTemplateSuccess =
  createAction<GetPartialSingleScheduleTemplateSuccessPayload>(
    'GET_PARTIAL_SINGLE_SCHEDULE_TEMPLATE_SUCCESS'
  )

export const resetScheduleTemplates = createAction('RESET_SCHEDULE_TEMPLATES')

export const removeScheduleTemplateRequest =
  createAction<RemoveScheduleTemplateRequestPayload>(
    'REMOVE_SCHEDULE_TEMPLATE_REQUEST'
  )
export const removeScheduleTemplateSuccess =
  createAction<RemoveScheduleTemplateSuccessPayload>(
    'REMOVE_SCHEDULE_TEMPLATE_SUCCESS'
  )
export const removeScheduleTemplateFailed = createAction(
  'REMOVE_SCHEDULE_TEMPLATE_FAILED'
)

export const addScheduleTemplateRequest =
  createAction<AddScheduleTemplateRequestPayload>(
    'ADD_SCHEDULE_TEMPLATE_REQUEST'
  )
export const addScheduleTemplateSuccess = createAction(
  'ADD_SCHEDULE_TEMPLATE_SUCCESS'
)
export const addScheduleTemplateFailed = createAction(
  'ADD_SCHEDULE_TEMPLATE_FAILED'
)

export const editScheduleTemplateRequest =
  createAction<EditScheduleTemplateRequestPayload>(
    'EDIT_SCHEDULE_TEMPLATE_REQUEST'
  )
export const editScheduleTemplateSuccess = createAction<ScheduleTemplateModel>(
  'EDIT_SCHEDULE_TEMPLATE_SUCCESS'
)
export const editScheduleTemplateFailed = createAction(
  'EDIT_SCHEDULE_TEMPLATE_FAILED'
)

export const deleteStScheduledExercisesByIdsRequest =
  createAction<DeleteStScheduledExercisesByIdsRequestPayload>('DELETE_ST_SCHEDULED_EXERCISES_BY_IDS_REQUEST')
export const deleteStScheduledExercisesByIdsSuccess =
  createAction<DeleteStScheduledExercisesByIdsSuccessPayload>('DELETE_ST_SCHEDULED_EXERCISES_BY_IDS_SUCCESS')
export const deleteStScheduledExercisesByIdsFailed =
  createAction('DELETE_ST_SCHEDULED_EXERCISES_BY_IDS_FAILED')

export const editStScheduledExercisesByIdsRequest =
  createAction<EditStScheduledExercisesByIdsRequestPayload>('EDIT_ST_SCHEDULED_EXERCISES_BY_IDS_REQUEST')
export const editStScheduledExercisesByIdsSuccess =
  createAction<EditStScheduledExercisesByIdsSuccessPayload>('EDIT_ST_SCHEDULED_EXERCISES_BY_IDS_SUCCESS')
export const editStScheduledExercisesByIdsFailed =
  createAction('EDIT_ST_SCHEDULED_EXERCISES_BY_IDS_FAILED')

export const addStScheduledExerciseRequest =
  createAction<AddStScheduledExerciseRequestPayload>('ADD_ST_SCHEDULED_EXERCISE_REQUEST')
export const addStScheduledExerciseSuccess =
  createAction<AddStScheduledExerciseSuccessPayload>('ADD_ST_SCHEDULED_EXERCISE_SUCCESS')
export const addStScheduledExerciseFailed =
  createAction('ADD_ST_SCHEDULED_EXERCISE_FAILED')

export const editStScheduledExerciseSettingsByIdsRequest =
  createAction<EditStScheduledExerciseSettingsByIdsRequestPayload>(
    'EDIT_ST_SCHEDULED_EXERCISE_SETTINGS_BY_IDS_REQUEST'
  )
export const editStScheduledExerciseSettingsByIdsSuccess =
  createAction<EditStScheduledExerciseSettingsByIdsSuccessPayload>(
    'EDIT_ST_SCHEDULED_EXERCISE_SETTINGS_BY_IDS_SUCCESS'
  )
export const editStScheduledExerciseSettingsByIdsFailed = createAction(
  'EDIT_ST_SCHEDULED_EXERCISE_SETTINGS_BY_IDS_FAILED'
)
